/**
 * @module builder
 */
import type { OptionsDocument } from 'paintscout'
import type { QuoteTypeOption } from '../index'
import { getFeature } from '../get-features'
import { getQuoteTypeOption } from './get-quote-type-option'

export function getQuoteTypeOptions(args: {
  options: OptionsDocument
  inactive?: boolean
  canDeactivate?: boolean
  hideAll?: boolean
  quoteTypes?: string[]
  deleted?: boolean
}): QuoteTypeOption[] {
  const { options, inactive, hideAll, quoteTypes, deleted = false, canDeactivate = true } = args
  const { intExtOptions } = options.options
  const hideAllQuoteType = getFeature({ options, path: 'quotes.hideAllQuoteType' })

  return intExtOptions.order
    .map((orderItem) => {
      return getQuoteTypeOption({ options, quoteType: orderItem })
    })
    .filter((item) => {
      if (!item) {
        return null
      }
      if (item.deleted && !deleted) {
        return null
      }
      if (item.key === 'all' && (hideAll || hideAllQuoteType)) {
        return null
      }
      if (canDeactivate && !inactive && item.active !== true && typeof item.active !== 'undefined') {
        return null
      }

      if (quoteTypes && !quoteTypes.includes(item.key) && !quoteTypes.includes('all')) {
        return null
      }

      return item
    })
}
